import listEmbeddableMixin from "@/mixins/embeddable/resource/listEmbeddableMixin";
import QuoteEmbeddable from "@/views/modules/business/Quote/embeddable/QuoteEmbeddable";
import http from "@/services/config/http-common";

export default {
    components:{QuoteEmbeddable},
    mixins: [listEmbeddableMixin],
    data() {
        return {
            path: "business/quote", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
            typeQuoteStatusOptions: [],
            companyOptions: [],
            paymentPlanOptions: [],
            sellerOptions: [],
        }

    },
    async mounted() {

        /*Declarar todos os campos no padrão que podem ser utilizados*/
        delete this.form.status


        const formDefault = {
            default: "", //NÃO ESQUECER DOS CAMPOS PADROES DE BUSCA COMO DEFAULT E STATUS (caso existir)
            customerId: 0,
            quoteStatusId: 0,
            sellerId: 0,
            paymentPlanId: 0,
            contactId: 0,
            companyId: 0,
            issueDate: "",
        }

        this.form = Object.assign({}, formDefault,this.form);

        await http.list(this.path + "/selectRelationList").then((response) => {

            this.typeQuoteStatusOptions = response.typeQuoteStatusOptions
            this.companyOptions = response.typeQuoteStatusOptions
            this.paymentPlanOptions = response.typeQuoteStatusOptions
            this.sellerOptions = response.typeQuoteStatusOptions

        }).catch(error => this.responseError(error))


    },
    methods:{

    }
}